//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Expression.js";
import "../no/Features.js";
import "../no/Expression.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"BendLocation",1,0],[0,"BendOptions",0,"Features.SheetMetal.BendOptions",0],[0,"DimensionType",1,0],[0,"DirectionType",1,0],[0,"ExtendProfile",1,0],[0,"FixedSide",1,0],[0,"Section",1,"Section",0],[0,"Sketch",1,"Features.SketchFeature",0],[0,"TargetFace",1,"Face",0]],[[[],"GetHeight",{R_:{height:"Expression"}},0,0],[[],"ValidateBuilderData",{R_:{builderDataValidity:''}},0,0]],[]];
SPLM.Features.SheetMetal.JogBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.JogBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.JogBuilder.DirectionTypeOptions = Object.freeze({
    "SectionNormalSide" : "SectionNormalSide", "SectionReverseNormalSide" : "SectionReverseNormalSide"});

SPLM.Features.SheetMetal.JogBuilder.FixedSideOptions = Object.freeze({
    "SectionSideLeft" : "SectionSideLeft", "SectionSideRight" : "SectionSideRight"});

SPLM.Features.SheetMetal.JogBuilder.DimensionTypeOptions = Object.freeze({
    "Offset" : "Offset", "Full" : "Full"});

SPLM.Features.SheetMetal.JogBuilder.BendLocationOptions = Object.freeze({
    "MaterialInside" : "MaterialInside", "MaterialOutside" : "MaterialOutside", "BendOutside" : "BendOutside"});

export default SPLM;